import { createUseStyles } from 'react-jss';

export default createUseStyles(
  {
    '@keyframes skeleton': {
      from: { opacity: 0.5 },
      to: { opacity: 1 },
    },

    block: {
      display: 'block',
    },

    round: {
      display: 'block',
      borderRadius: '50%',
      overflow: 'hidden',
      ['@media (max-width: 768px)']: {
        height: 30,
        width: 30,
      },
    },

    root: {
      pointerEvents: 'none',
      color: 'transparent !important',

      '& *': {
        color: 'inherit !important',
      },

      '& span': {
        background: '#00000014',
        animation: '$skeleton 1s infinite ease-in-out alternate',
        borderRadius: 2,
      },
    },
  },
  {
    name: 'Skeleton',
  },
);
